export const config = {
  apiBaseUrl: process.env.NEXT_PUBLIC_API_URL,
  intercomId: process.env.NEXT_PUBLIC_INTERCOM_APP_ID,
  stripePk: process.env.NEXT_PUBLIC_STRIPE_KEY,
  googlePlacesApi: process.env.NEXT_PUBLIC_PLACES_API_KEY,
  postHogKey: process.env.NEXT_PUBLIC_POSTHOG_KEY,
  postHogHost: process.env.NEXT_PUBLIC_POSTHOG_HOST,
  // Not using node-env since it's limited to dev, test, and production
  environment: (process.env.NEXT_PUBLIC_ENV || "staging") as
    | "staging"
    | "sandbox"
    | "production",
  streamKey: process.env.NEXT_PUBLIC_STREAM_KEY,
  datadog: {
    clientToken: process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN,
    applicationId: process.env.NEXT_PUBLIC_DD_APPLICATION_ID
  },
  pxOrigin: process.env.NEXT_PUBLIC_PX_ORIGIN,
  buildId: process.env.NEXT_PUBLIC_BUILD_ID
};
